import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../environment.js";
import { Button, Form, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import Loader from "../Components/Loader.js";
import Select from "react-select";
import Toggle from "react-toggle";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Dropdown from "react-bootstrap/Dropdown";
import "./leadexe.css";
import NavbarNew from "../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const LeadExe = ({ history, match, props }) => {
  const [dap_users, setUsers] = useState([]);
  // const [dap_firstName, setFirstName] = useState("");
  // const [dap_lastName, setLastName] = useState("");
  // const [dap_phone, setPhone] = useState("");
  // const [dap_email, setEmail] = useState("");
  // const [billable, setBillable] = useState("");
  // const [dap_address, setAddress] = useState("");
  // const [dap_city, setDapCity] = useState([]);
  // const [dap_states, setDapState] = useState([]);
  // const [countrycode, setCountryCode] = useState("");
  // const [postcountry, setPostCountry] = useState("");
  // const [postcity, setPostCity] = useState("");
  // const [poststate, setPostState] = useState("");

  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [zip, setZip] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [toggleChecked, setToggleChecked] = useState(false);
  const [loader, setLoader] = useState(true);
  const [show, setShow] = useState(false);
  const [showConvertCustomer, setShowConvertCustomer] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    // console.log(device_id);
    // console.log("hello");
    // SetDeviceId(device_id);
    setShow(true);
  };
  const handleShowConvertCustomer = () => {
    setShowConvertCustomer(true);
  };
  const handleCloseCovertCustomer = () => {
    setShowConvertCustomer(false);
  };
  const [partners, setPartners] = useState([]);
  const [tenantIdMongo, setTenantIdMongo] = useState("");
  const [tenantId, setTenantId] = useState("");
  const [tenantUserId, setUserTenantId] = useState("");
  const [organization, setOrganization] = useState("");

  let roles = [];
  roles = [
    {
      roleType: "Lead Executive",
      roleId: 1,
    },
  ];

  // const dap_id = match.params.id;
  const toggle = () => {
    setToggleChecked(true);
  };
  const fetchAllLeads = () => {
    axios
      .get(
        `${
          environment.dap_url
        }crm_api/getLeadByLeadExecutiveId?lead_executive_id=${
          JSON.parse(localStorage.getItem("executivedetails"))._id
        }&partnerId=${
          JSON.parse(localStorage.getItem("executivedetails")).createdBy
        }`
      )
      .then((res) => {
        // const dap_users = res.data;
        console.log(res);
        setUsers(res.data);
        console.log(res.data);
      })
      .catch(function (error) {
        console.log(error);
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };
  useEffect((e) => {
    Data();

    axios.get(environment.dap_url + "partnerApi/getAll").then((res) => {
      console.log(res.data);
      const parent = JSON.parse(
        localStorage.getItem("executivedetails")
      ).createdBy;
      console.log(parent);
      const data = res.data;
      const mydata = data.filter((item) => item._id == parent);
      setPartners(mydata);
    });
    function formatEmail(cell, row) {
      const status = row.status;
      const color = status === 2 ? "red" : "";
      return <span style={{ color }}>{cell}</span>;
    }
  }, []);

  // const deleteHandler = (id) => {
  //   // console.log(id);
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes",
  //   }).then(function (result) {
  //     if (result.isConfirmed) {
  //       axios
  //         .delete(environment.dap_url + "crm_api/DeleteLeads?Id=" + id)
  //         .then((res) => {
  //           console.log(res);
  //           MySwal.fire({
  //             title: <p>Lead has been successfully deleted!</p>,
  //             type: "success",
  //           });
  //           //history.push("/customers");
  //           axios
  //             .get(
  //               `${
  //                 environment.dap_url
  //               }crm_api/getLeadByLeadExecutiveId?lead_executive_id=${
  //                 JSON.parse(localStorage.getItem("executivedetails"))._id
  //               }&
  //           ("executivedetails")).createdBy}`
  //             )
  //             .then((res) => {
  //               setUsers(res.data);
  //             })
  //             .catch((err) => {});
  //         })
  //         .catch((err) => {
  //           MySwal.fire({
  //             title: (
  //               <p>{err?.response?.data?.message || "Lead deletion failed"}</p>
  //             ),
  //             type: "error",
  //           });
  //         });
  //     }
  //   });
  // };

  // let user = JSON.parse(localStorage.getItem("user"))

  const Data = () => {
    // console.log("hii");
    console.log(JSON.parse(localStorage.getItem("executivedetails"))._id);
    axios
      .get(
        `${
          environment.dap_url
        }crm_api/getLeadByLeadExecutiveId?lead_executive_id=${
          JSON.parse(localStorage.getItem("executivedetails"))._id
        }&partnerId=${
          JSON.parse(localStorage.getItem("executivedetails")).createdBy
        }`
      )
      .then((res) => {
        // const dap_users = res.data;
        console.log(res);
        setUsers(res.data);
        console.log(res.data);
      })
      .catch(function (error) {
        console.log(error);
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };

  const setPartnerData = (e) => {
    console.log(e.value);
    setTenantId(e.value.tenant_id);
    setTenantIdMongo(e.value.tenant_id_mongo);
    setUserTenantId(e.value.tenant_user_id);

    // setUserTenantId(user.createdById);
  };

  const LeadExecutive = (id) => {
    // let id1 = match.params.id;
    console.log(id);
    setShow(false);
    // let device_id = deviceId;
    // let tenant_id = e.value;
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        // console.log(tenant_id.id);
        // console.log(device_id);
        axios
          .get(
            environment.dap_url +
              "crm_api/getLeadByLeadExecutiveId?lead_executive_id=" +
              id
            // {
            //   lead_executive_id: id,
            // }
          )
          .then((res) => {
            MySwal.fire({
              title: <p>Lead has been assigned successfully!</p>,
              type: "success",
            });
            // getAllNodeDevices();
          })
          .catch((err) => {
            MySwal.fire({
              title: <p>Lead couldn't be assigned at the moment</p>,
              type: "error",
            });
          });
      }
    });
  };

  async function startConversion(
    c_userFirstName,
    c_userLastName,
    c_country,
    c_state,
    c_city,
    c_address,
    c_zip,
    c_phone,
    c_email,
    c_organisation
  ) {
    let reqBody = {
      tenant_id: "bece6c20-f95c-11ed-bfa6-85628fc0a3af",
      id: "623312b0-f969-11ed-bfa6-85628fc0a3af",
      userFirstName: c_userFirstName,
      userLastName: c_userLastName,
      country: c_country,
      state: c_state,
      city: c_city,
      address: c_address,
      zip: c_zip,
      phone: c_phone,
      email: c_email,
      title: c_organisation,
    };

    await axios
      .post(environment.dap_url + "external_api/convertCustomer", reqBody, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log("conversion-response");
        console.log("convert", res);
        if (res) {
          MySwal.fire({
            title: <p>Email sent to the user</p>,
            type: "success",
          });

          let parentId = JSON.parse(
            localStorage.getItem("executivedetails")
          ).createdBy;
          let createdBy = JSON.parse(
            localStorage.getItem("executivedetails")
          )._id;
          console.log("hiii");
          axios
            .post(environment.dap_url + "external_api/getLeadByMail", {
              email: c_email,
            })
            .then((user) => {
              console.log(user.data.source);
              console.log("convert", user);

              let reqBody1 = {
                tenant_id: "bece6c20-f95c-11ed-bfa6-85628fc0a3af",
                id: "623312b0-f969-11ed-bfa6-85628fc0a3af",

                userFirstName: c_userFirstName,
                userLastName: c_userLastName,
                source: user.data.source,
                industry: user.data.industry,
                designation: user.data.designation,
                isBillable: user.data.isBillable,
                package: user.data.package,
                country: c_country,
                state: c_state,
                city: c_city,
                address: c_address,
                zip: c_zip,
                phone: c_phone,
                email: c_email,
                title: c_organisation,
                parentId: parentId,
                createdBy: createdBy,
              };
              axios
                .post(
                  environment.dap_url + "external_api/assigntoPartner",
                  reqBody1,
                  {
                    headers: {
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((res) => {
                  console.log("assign-to-partner-response");
                  console.log("convert", res);
                  if (res) {
                    MySwal.fire({
                      title: <p>Lead Converted to Customer</p>,
                      type: "success",
                    });
                  }

                  axios
                    .get(
                      `${
                        environment.dap_url
                      }crm_api/getLeadByLeadExecutiveId?lead_executive_id=${
                        JSON.parse(localStorage.getItem("executivedetails"))._id
                      }&partnerId=${
                        JSON.parse(localStorage.getItem("executivedetails"))
                          .createdBy
                      }`
                    )
                    .then((res) => {
                      // const dap_users = res.data;
                      console.log("convert", res);
                      setUsers(res.data);
                      console.log(res.data);
                    })
                    .catch(function (error) {
                      console.log(error);
                      MySwal.fire({
                        title: <p>{error.message}</p>,
                        type: "error",
                      });
                    });
                });
              axios
                .get(environment.dap_url + "partnerApi/getAll")
                .then((res) => {
                  console.log(res.data);
                  const parent = JSON.parse(
                    localStorage.getItem("executivedetails")
                  ).createdBy;
                  console.log(parent);
                  const data = res.data;
                  const mydata = data.filter((item) => item._id == parent);
                  setPartners(mydata);
                });
            })
            .catch((err) => {
              console.log(err);
              MySwal.fire({
                title: (
                  <p>
                    {err?.response?.data?.message ||
                      "Assigning to partner failed"}
                  </p>
                ),
                type: "error",
              });
            });
        }
      })

      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: (
            <p>{err?.response?.data?.message || "Customer Creation failed"}</p>
          ),
          type: "error",
        });
      });
  }

  const setCustomerData = (id) => {
    console.log(id);
    axios
      .get(environment.dap_url + "crm_api/getLeadsById?id=" + id)
      // alert(JSON.parse(localStorage.getItem("executivedetails")).createdBy)
      .then((res) => {
        // setUsers(res.data);
        setEmail(res.data.email);
        setfirstName(res.data.userFirstName);
        setlastName(res.data.userLastName);
        // setName(res.data.userFirstName + " " + res.data.userLastName);
        setPhone(res.data.phone);
        setAddress(res.data.address);
        setCountry(res.data.country);
        setState(res.data.state);
        setCity(res.data.city);
        setZip(res.data.zip);
        setOrganization(res.data.organization);
        console.log(res.data);

        MySwal.fire({
          title: "Are you sure?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
        }).then(function (result) {
          if (result.isConfirmed) {
            //console.log("hii");
            startConversion(
              res.data.userFirstName,
              res.data.userLastName,
              res.data.country,
              res.data.state,
              res.data.city,
              res.data.address,
              res.data.zip,
              res.data.phone,
              res.data.email,
              res.data.organization
            );
            MySwal.fire({
              title: <p>Lead has been assigned successfully!</p>,
              type: "success",
            });
          }
        });
      });
    fetchAllLeads();
  };

  const PutHold = (id) => {
    console.log(id);

    axios
      .get(environment.dap_url + "crm_api/toggleStatus" + "?id=" + id)
      .then((res) => {
        MySwal.fire({
          title: <p>Are you sure?</p>,
          type: "success",
        }).then(() => {
          window.location.reload();
        });
      });
  };

  const columns = [
    {
      dataField: "sl.no",
      text: "Sl no.",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        // console.log(dataField+' '+lname)
        return row.userFirstName + " " + row.userLastName;
      },
    },
    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        let dateTimeArr = dataField.split("T");
        let dateArr = dateTimeArr[0].split("-");
        let dateFinal = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
        return dateFinal;
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      formatter: (cell, row) => {
        const status = row.status;
        const color = status === 2 ? "red" : "";
        return <span style={{ color }}>{cell}</span>;
      },
    },

    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "organization",
      text: "Organization",
      sort: true,
    },
    {
      dataField: "source",
      text: "Source",
      sort: true,
    },
    {
      dataField: "probability",
      text: "Probability",
      sort: true,
    },
    {
      dataField: "industry",
      text: "Industry",
      sort: true,
    },

    {
      dataField: "country",
      text: "Country",
      sort: true,
    },
    {
      dataField: "state",
      text: "State",
      sort: true,
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
    },
    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (row, cell, rowIndex, formatExtraData) => {
        if (cell.status == 0) {
          return (
            <div>
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  Action
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {/* <Dropdown.Item onClick={() => deleteHandler(dataField)}>
                    <i className="fa fa-trash-o"></i>&nbsp; &nbsp; Delete
                  </Dropdown.Item> */}
                  <Dropdown.Item href={`/leads/view/` + cell._id}>
                    <i className="fa fa-eye"></i>&nbsp; &nbsp; View
                  </Dropdown.Item>
                  <Dropdown.Item href={`/leads/edit/` + cell._id}>
                    <i className="fa fa-edit "></i>&nbsp; &nbsp; Edit
                  </Dropdown.Item>

                  <Dropdown.Item href={`/followup-history/` + cell._id}>
                    <i className="fa fa-users"></i>&nbsp; &nbsp; Follow Up
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      PutHold(cell._id);
                    }}
                  >
                    <i class="fas fa-hand-holding"></i>&nbsp; &nbsp; Hold
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setCustomerData(cell._id);
                    }}
                  >
                    <i className="fa fa-users"></i>&nbsp; &nbsp; Convert To
                    Customer
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        } else {
          return (
            <div>
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  Action
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {/* <Dropdown.Item onClick={() => deleteHandler(dataField)}>
                    <i className="fa fa-trash-o"></i>&nbsp; &nbsp; Delete
                  </Dropdown.Item> */}
                  <Dropdown.Item
                    href={`/leads/edit/` + dap_users[rowIndex]._id}
                  >
                    <i className="fa fa-edit "></i>&nbsp; &nbsp; Edit
                  </Dropdown.Item>
                  <Dropdown.Item
                    href={`/leads/view/` + dap_users[rowIndex]._id}
                  >
                    <i className="fa fa-eye"></i>&nbsp; &nbsp; View
                  </Dropdown.Item>

                  <Dropdown.Item
                    href={`/followup-history/` + dap_users[rowIndex]._id}
                  >
                    <i className="fa fa-users"></i>&nbsp; &nbsp; Follow Up
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      PutHold(cell._id);
                    }}
                  >
                    <i className="fa fa-users"></i>&nbsp; &nbsp; Un hold
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        }
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  return (
    <div>
      <>
        <NavbarNew />
        <div className="row" style={{ marginTop: "2%", padding: "10px" }}>
          <div className="col-lg-6"></div>
          <div className="col-lg-6">
            <LinkContainer
              to={`/leads/create`}
              style={{
                paddingTop: "18px",
                float: "right",
              }}
            >
              <Button variant="light" className="btn btn-light my-3">
                Add Leads
              </Button>
            </LinkContainer>
          </div>
        </div>

        <div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">LEADS</h4>
                  <div className="row">
                    <div className="col-12">
                      <ToolkitProvider
                        keyField="id"
                        bootstrap4
                        data={dap_users}
                        columns={columns}
                        search
                      >
                        {(props) => (
                          <div>
                            <div className="d-flex align-items-center">
                              <p className="mb-2 mr-2">Search in table:</p>
                              <SearchBar {...props.searchProps} />
                            </div>
                            <BootstrapTable
                              defaultSorted={defaultSorted}
                              pagination={paginationFactory()}
                              {...props.baseProps}
                              wrapperClasses="table-responsiv"
                            />
                          </div>
                        )}
                      </ToolkitProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            {/* <Modal.Title> {deviceData.deviceName} </Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <Form className="mx-auto" show={show} onHide={handleClose}>
              <Form.Group controlId="AccessToken">
                {/* <Form.Label> Lead Executive Id </Form.Label> */}
                <Modal.Body>
                  <Form.Label>LEAD Executive </Form.Label>
                  <Select
                    options={roles.map((element) => ({
                      id: element.roleType,
                      value: element.roleType,
                      label: element.roleType,
                    }))}
                    defaultValue="hi there"
                    placeholder={"Lead Executive"}
                  />
                </Modal.Body>
              </Form.Group>
            </Form>

            <div className="my-2 d-flex justify-content-between align-items-center mx-auto">
              <div className=" mx-auto">
                <Button
                  type="submit"
                  className="btn btn-block btn-primary btn-sm font-weight-medium auth-form-btn"
                  onClick={() => {
                    LeadExecutive();
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light btn-sm" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showConvertCustomer} onHide={handleCloseCovertCustomer}>
          <Modal.Header>
            <Modal.Title>Choose Partner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Select
              options={partners.map((element) => ({
                id: element._id,
                value: {
                  tenant_id: element.tenantId,
                  tenant_id_mongo: element._id,
                  tenant_user_id: element.userId,
                },
                label: element.userFirstName + " " + element.userLastName,
              }))}
              // defaultValue="hi there"
              // value={}
              placeholder={"Choose Partner"}
              // placeholder={deviceData.accessToken}
              onChange={(e) => setPartnerData(e)}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleCloseCovertCustomer} variant="warning">
              Close
            </Button>
            <Button
              onClick={() => {
                startConversion();
              }}
            >
              Convert to Customer
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </div>
  );
};

export default LeadExe;
